import { PackH5 as Webview } from '@/proto/Pack'
import { Params, getRequest } from './request'
// import { IAnswer } from './answer'
// import { Timer } from './questionnaireTimer'
import { closeBrowserPage } from './closeBrowserPage'
import { store } from '@/stores/main'

export function getUrlParams(): Params & {
  url?: string
  code: string
  userid: string | number
  token?: string
  brand?: string
  lang: string
  jsb?: string
  order_id?: string
  payment_voucher?: string
} {
  // 使用es5的方式获取url参数
  const url = window.location.href
  const params: any = {}
  const splitSharp = url.split('#')

  splitSharp.forEach((item) => {
    parse(item)
  })

  function parse(path: string) {
    const str = path.split('?')[1]
    if (str) {
      const strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        params[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
      }
    }
  }
  const oldParams = store.urlParmas
  const merge = {
    ...oldParams,
    ...params,
  }
  store.urlParmas = merge
  return {
    ...merge,
  }
}

export async function fetchSurvey() {
  const path = 'https://h5api.zenam.net/act/survey/get'
  const { GetSurveyReq, GetSurveyResp } = Webview
  const request = getRequest<typeof GetSurveyReq, typeof GetSurveyResp>(GetSurveyReq, GetSurveyResp)
  return await request(path, {
    // act_id,
  })
}

export async function submitSurvey() {
  const path = '/act/survey/submit'
  const { SubmitSurveyReq, SubmitSurveyResp } = Webview
  const request = getRequest<typeof SubmitSurveyReq, typeof SubmitSurveyResp>(
    SubmitSurveyReq,
    SubmitSurveyResp
  )
  return await request(path, {
    // question_content,
    // write_time: Timer.getTime(),
    // act_id: survey_conf_id,
  })
}

/* ----------   kyc    ------- */
// 获取kyc详情
export async function fetchKyc() {
  const path = '/user/kyc/get_kyc/'
  const { GetKycReq, GetKycResp } = Webview
  const request = getRequest<typeof GetKycReq, typeof GetKycResp>(GetKycReq, GetKycResp)
  return await request(path, {})
}

// 提交kyc
export async function submitKyc(params: any) {
  const path = '/user/kyc/set_kyc/'
  const { SetKycReq, SetKycResp } = Webview
  const request = getRequest<typeof SetKycReq, typeof SetKycResp>(SetKycReq, SetKycResp)
  return await request(path, { ...params })
}

// 获取上传图片地址
export async function fetchUploadUrl(pan_id: string) {
  const path = '/user/kyc/get_kyc_pre_url/'
  const { GetKycPreUrlReq, GetKycPreUrlResp } = Webview
  const request = getRequest<typeof GetKycPreUrlReq, typeof GetKycPreUrlResp>(
    GetKycPreUrlReq,
    GetKycPreUrlResp
  )
  return await request(path, { pan_id })
}

/* ----------   order    ------- */
// pay/get_pay_info/
// 获取支付信息
export async function getPayInfo(order_id: any) {
  const path = '/pay/get_pay_info/'
  const { GetPayInfoReq, GetPayInfoResp } = Webview
  const request = getRequest<typeof GetPayInfoReq, typeof GetPayInfoResp>(
    GetPayInfoReq,
    GetPayInfoResp
  )
  return await request(path, { order_id })
}

// pay/get_payment_voucher_pre_url/
// 获取支付凭证上传的预提交 url
export async function getPaymentVoucherPreUrl(order_id: any) {
  const path = '/pay/get_payment_voucher_pre_url/'
  const { GetPaymentVoucherPreUrlReq, GetPaymentVoucherPreUrlResp } = Webview
  const request = getRequest<typeof GetPaymentVoucherPreUrlReq, typeof GetPaymentVoucherPreUrlResp>(
    GetPaymentVoucherPreUrlReq,
    GetPaymentVoucherPreUrlResp
  )
  return await request(path, { order_id })
}
// pay/submit_payment_voucher/
// 提交支付凭证
export async function submitPaymentVoucher(params: any) {
  const path = '/pay/submit_payment_voucher/'
  const { SubmitPaymentVoucherReq, SubmitPaymentVoucherResp } = Webview
  const request = getRequest<typeof SubmitPaymentVoucherReq, typeof SubmitPaymentVoucherResp>(
    SubmitPaymentVoucherReq,
    SubmitPaymentVoucherResp
  )
  return await request(path, { ...params })
}
// /pay/cancel_inner_pay_order/
// 取消内部的支付订单
export async function cancelInnerPayOrder(order_id: number) {
  const path = '/pay/cancel_inner_pay_order/'
  const { CancelInnerPayOrderReq, CancelInnerPayOrderResp } = Webview
  const request = getRequest<typeof CancelInnerPayOrderReq, typeof CancelInnerPayOrderResp>(
    CancelInnerPayOrderReq,
    CancelInnerPayOrderResp
  )
  return await request(path, { order_id })
}
export const close = () => {
  if (window.location.pathname === '/preview') {
    // 预览时使用
    window.parent.postMessage(
      {
        type: 'survey-close',
      },
      '*'
    )
  } else {
    closeBrowserPage()
  }
}

export function enableLog() {
  return true
}

export function randomArray(arr: any[]) {
  return arr.sort(() => Math.random() - 0.5)
}

export function getOptionsExceptOther(options: any) {
  // 提取 other 选项，将其放在最后，并且剩余选项乱序
  const other = options.find((item: any) => item.isOther)
  const rest = options.filter((item: any) => !item.isOther)
  const randomRest = randomArray(rest)
  if (other) {
    return [...randomRest, other]
  }
  return randomRest
}

export function assertNaN(num: any) {
  return Object.prototype.toString.call(num) === '[object Number]' && num !== num
}
export const isProd = () => {
  return process.env.NODE_ENV === 'production'
}

export function isDev() {
  return process.env.NODE_ENV === 'development'
}
export function getDomain() {
  const protocol = document.location.protocol
  const domain = document.domain
  return isProd()
    ? `${protocol}//${domain.replace('lobby-h5', 'h5api')}`
    : 'https://h5api.vn-test.net'
}

export const rmbFormat = (value: number) => (value ? (Math.floor(value) / 1000) * 1 : 0)

/** 提交文件到仓库 */
export const uploadFile = async (cdnUrl: string, abuf: ArrayBuffer): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const xreq = new XMLHttpRequest()
    xreq.onreadystatechange = function (res) {
      console.log(res)
      if (xreq.readyState != 4) {
        return
      }
      if (xreq.status != 200) {
        resolve(false)
        return
      }

      resolve(true)
      console.log('reject', reject)
    }
    xreq.onerror = function (err) {
      console.log(err)
    }
    xreq.open('PUT', cdnUrl)
    console.log(cdnUrl)
    // xreq.setRequestHeader("Content-type","application/x-www-form-urlencoded");
    xreq.setRequestHeader('Content-type', 'video/mp4')
    xreq.send(abuf)
  })
}

//aase64转换rraybuffb
export const base64ToArrayBuffer = (base64: string) => {
  console.log('base64', base64)
  // var type = base64.split(",")[0].match(/:(.*?);/)[1]; //提取base64头的type如 'image/png'
  const content = base64.split(',')[1]
  const bytes = window.atob(content) //去掉url的头，并转换为byte (atob:编码 btoa:解码)
  //处理异常,将ascii码小于0的转换为大于0
  const ia = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  console.log('ia')
  return ia.buffer
}

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

// 区分pc和移动端
export const isMobile = () => {
  const userAgent = navigator.userAgent
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(userAgent)
}
